<template>
  <el-dialog
    title="記事を投稿"
    :visible="addDialog"
    :before-close="closePackage"
    class="add"
    top="30px"
    width="1232px">
    <el-form
      ref="dataForm"
      :rules="addDialogRules"
      :model="ArticleData"
      label-width="80px"
      label-position="left"
      :hide-required-asterisk="false"
    >
      <el-form-item
        label="タイトル"
        prop="title"
        style="width: 48%; display: inline-block;"
      >
        <el-input style="width: 306px;" v-model="ArticleData.title"></el-input>
      </el-form-item>
      <el-form-item
        label="国家"
        prop="countryAreaId"
        style="width: 25%; display: inline-block;"
      >
        <el-select
          v-model="ArticleData.countryAreaId"
          clearable
          class="filter-item"
          placeholder="国家選択"
          style="width: 148px;"
          @change="onCountryFun()"
        >
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="都市"
        prop="areaId"
        style="width: 25%; display: inline-block;"
      >
        <el-select
          v-model="ArticleData.areaId"
          clearable
          class="filter-item"
          placeholder="都市選択"
          style="width: 148px;"
        >
          <el-option
            v-for="item in AreaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="タグ" prop="articleTagIds" style="width: 48%; display: inline-block;">
        <el-select
          v-model="ArticleData.articleTagIds"
          multiple :multiple-limit="1" 
          clearable
          collapse-tags
          style="width: 230px"
          placeholder="選択"
        >
          <el-option
            v-for="item in articleTagsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 230px"
          >
          </el-option>
        </el-select>
        <div style="font-size:12px;margin-left:-15%;margin-top:10px;line-height: 22px;">
          <span>*コンテンツと関係のないタグは選択されないようにご注意ください。</span><br />
          <span>*なるべく同じタグを選んでいただいたほうが読者の目に触れやすくなります。</span><br />
          <span>（例）人材紹介会社→求人NAVI  中国語スクール→教育  不動産仲介→お住まい</span>
        </div>
      </el-form-item>
      <el-form-item
        label="表紙"
        prop="images"
        style="width: 48%; display: inline-block;vertical-align: top;"
      >
        <el-upload
          list-type="picture-card"
          action="http://47.242.180.16:8085/file/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="ArticleData.images.length > 0"
            :src="ArticleData.images"
            class="avatar"
            style="width: 148px;height: 148px;"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="微信URL"
        style="width: 100%; display: inline-block"
      >
        <el-input
          v-model="ArticleData.wxAddress"
          style="width: 40%; display: inline-block"
        /><el-button
          style="margin-left: 20px; display: inline-block"
          @click="getTransform"
          >記事に変換</el-button
        ><el-button
          style="margin-left: 20px; display: inline-block"
          @click="getTransform2"
          >リロード</el-button
        >
        <el-button
          style="margin-left: 20px; display: inline-block"
          @click="lockcontent('',ArticleData.content)"
          >プレビュー</el-button
        >
      </el-form-item>
      <!-- <el-form-item
        label="投稿予約する/しない"
        style="width: 150px; display: inline-block"
        label-width="100px"
        class="item"
      >
        <el-switch v-model="timing" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item
        label="投稿日時"
        style="width: 100%; display: inline-block"
        v-if="timing"
      >
        <el-date-picker
          v-model="timeDate"
          type="datetime"
          :picker-options="pickerOptions"
          placeholder="日時選択">
        </el-date-picker>
      </el-form-item> -->
      <div>
        <editor-bar
          v-model="ArticleData.content"
          :isClear="isClear"
          @change="change"
        ></editor-bar>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closePackage()">キャンセル</el-button>
      <el-button @click="savaDraft()">下書きを保存</el-button>
      <el-button type="primary" @click="addArticleFun()">投稿</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import * as json from '@/assets/js/json'
  import EditorBar from "@/components/editoritem";
  export default{
    props:{
      addDialog: {
        type: Boolean,
        default: false,
      },
      articleTagsList: {
        type: Array,
        default: []
      }
    },
    components: {
      EditorBar
    },
    data() {
      return {
        addDialogRules: {
          title: [{ required: true, message: "タイトルを入力してください", trigger: "change" }],
          images: [{ required: true, message: "画像をアップロードしてください", trigger: "blur" }],
          countryAreaId: [{ required: true, message: "地域を入力してください", trigger: "blur" }],
          areaId: [{ required: true, message: "地域を入力してください", trigger: "blur" }],
          articleTagIds: [{ required: true, message: "タグを入力してください", trigger: "blur" }]
        },
        ArticleData:{
          title: "",
          countryAreaId:null,
          areaId: null,
          images: [],
          wxAddress: "",
          content: "",
          articleTagIds:[],
          type: { value: "common", enum: "COMMON", desc: "普通" },
          status: "",
          isTimedPublish:false,
          videoUrl: '',
          videoImage: ''
        },
        timing:false,
        isClear: false,
        countryList:[],
        AreaList: [],
      }
    },
    created () {
      this.getArea()
      if(window.localStorage.getItem('articleDraft')){
        this.ArticleData = JSON.parse(window.localStorage.getItem('articleDraft'))
        window.localStorage.removeItem('articleDraft')
      }else{
        this.ArticleData = {
          title: "",
          countryAreaId:null,
          areaId: null,
          images: [],
          wxAddress: "",
          content: "",
          articleTagIds:[],
          type: { value: "common", enum: "COMMON", desc: "普通" },
          status: "",
          isTimedPublish:false,
          videoUrl: '',
          videoImage: ''
        }
      }
    },
    methods: {
      getArea(){
        json.post('/api/member/index/area/list').then((res) =>{
          this.countryList = res.data.data.areas
        })
      },
      onCountryFun(){
        let mergedArray = null
        this.AreaList = []
        console.log(this.ArticleData.countryAreaId)
        this.countryList.forEach(item =>{
        if(this.ArticleData.countryAreaId == item.id){
          this.AreaList.push(item)
          mergedArray = this.AreaList.concat(item.children)
          this.AreaList = mergedArray
        }
      })
      },
      handleAvatarSuccess(res, file) {
        this.ArticleData.images = [];
        this.closeFullScreen();
        this.ArticleData.images.push(res.data.url);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        this.openFullScreen("上传中...");
        return;
      },
      getTransform(){
        this.openFullScreen("转换中...");
        json.uploadPost('/api/userSystem/article/transform/?url='+this.ArticleData.wxAddress).then((res)=>{
          if(res.data.success){
            this.ArticleData.content = res.data.data.content;
          }
          this.closeFullScreen();
        })
      },
      getTransform2(){
        this.openFullScreen("リロード中...");
        let content = this.ArticleData.content
        this.ArticleData.content = ''
        setTimeout(() => {
          this.ArticleData.content = content
          this.closeFullScreen();
        }, 1000);
      },
      lockcontent(title, content){
        this.$parent.lockcontent(title, content)
      },
      savaDraft(){
        window.localStorage.setItem('articleDraft', JSON.stringify(this.ArticleData))
        this.closePackage()
      },
      change(){},
      closePackage() {
        this.$emit("update:addDialog", false);
      },
      addArticleFun(){
        this.$refs['dataForm'].validate((valid) => {
          if(valid){
            json.uploadPost('/api/userSystem/article/add',this.ArticleData).then((res)=>{
              if (res.data.success) {
                this.closePackage()
              }
              this.$parent.getList()
            })
          }
        })
      },
      openFullScreen(text) {
        this.loading = this.$loading({
          lock: true,
          text: text,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      closeFullScreen(){
        this.loading.close();
      },
    },
  }
</script>